import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { DialogCloseResult, DialogService } from '@progress/kendo-angular-dialog';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ModalPopupImplComponent } from '../modalpopup/modal-popup-impl/modal-popup-impl.component';
import { DirtyFormChecker } from './DirtyFormChecker';

/**
 * Checks if the form can be deactivated based on unsaved changes. 
 * Can be used to prevent route change.
 * Includes
 * ```
 * canDeactivate(component: DirtyFormChecker)
 * ```
 * method and it works for the form check
 * @param component - Component implementing DirtyFormChecker interface.
 * @returns Observable<boolean> | boolean - Whether the form can be deactivated.
 */
@Injectable()
export class UnSavedChangesRouteGuard implements CanDeactivate<DirtyFormChecker> {
  constructor(private dialogService: DialogService) { }


  canDeactivate(component: DirtyFormChecker): Observable<boolean> | boolean {
    if (component.hasUnsavedData?.()) {
      const dialog = this.dialogService.open({
        content: ModalPopupImplComponent,
      });

      return dialog.result.pipe(
        map((result: any) => {
          if (result instanceof DialogCloseResult) {
            return false;
          }
          if (result.primary) {
            return true;
          } else {
            return false;
          }
        }),
        take(1)
      );
    } else {
      return true;
    }
  }
}
